import { CSSProperties } from 'react';

import classes from './Spinner.module.scss';

export type SpinnerProps = {
  className?: string;
  size?: number;
  thickness?: number;
  color?: string;
};
export const Spinner = ({
  className,
  size = 60,
  thickness = 4,
  color = '#056fff',
}: SpinnerProps) => {
  const rootStyle: CSSProperties = {
    width: size,
    height: size,
  };

  const ringStyle: CSSProperties = {
    ...rootStyle,
    borderWidth: thickness,
    borderColor: color,
  };
  return (
    <div className={className} style={rootStyle}>
      <div className={classes.circle} style={ringStyle} />
    </div>
  );
};
